/*
 * @Author: songjingyang songjingyang@meishubao.com
 * @Date: 2025-03-28 15:40:04
 * @LastEditors: songjiangyang songjingyang@meishubao.com
 * @LastEditTime: 2026-04-29 18:09:59
 * @FilePath: src/plugins/auth.ts
 * @Description: TypeScript版本 - 自动转换
 */

import useUserStore from '@/store/modules/user'

function authPermission(permission: any): any {
  const all_permission = '*:*:*'
  const permissions = useUserStore().permissions
  if (permission && permission.length > 0) {
    return permissions.some(v => {
      return all_permission === v || v === permission
    })
  } else {
    return false
  }
}

function authRole(role: any): any {
  const super_admin = 'admin'
  const roles = useUserStore().roles
  console.log('🚀 ~ authRole ~ roles:', roles)
  if (role && role.length > 0) {
    return roles.some(v => {
      return super_admin === v || v === role
    })
  } else {
    return false
  }
}

// {{ AURA-X: Add - 角色前缀匹配：admin 超管自动通过，其余按前缀匹配。Approval: 寸止. }}
function authRolePrefix(prefix: any): any {
  const super_admin = 'admin'
  const roles = useUserStore().roles
  if (prefix && prefix.length > 0) {
    return roles.some(v => {
      return super_admin === v || (typeof v === 'string' && v.startsWith(prefix))
    })
  } else {
    return false
  }
}

export default {
  // 验证用户是否具备某权限
  hasPermi(permission) {
    return authPermission(permission)
  },
  // 验证用户是否含有指定权限，只需包含其中一个
  hasPermiOr(permissions) {
    return permissions.some(item => {
      return authPermission(item)
    })
  },
  // 验证用户是否含有指定权限，必须全部拥有
  hasPermiAnd(permissions) {
    return permissions.every(item => {
      return authPermission(item)
    })
  },
  // 验证用户是否具备某角色
  hasRole(role) {
    return authRole(role)
  },
  // 验证用户是否含有指定角色，只需包含其中一个
  hasRoleOr(roles) {
    return roles.some(item => {
      return authRole(item)
    })
  },
  // 验证用户是否含有指定角色，必须全部拥有
  hasRoleAnd(roles) {
    return roles.every(item => {
      return authRole(item)
    })
  },
  // {{ AURA-X: Add - 判断用户是否拥有以指定前缀开头的角色（admin 超管直接通过）。Approval: 寸止. }}
  hasRolePrefix(prefix: string) {
    return authRolePrefix(prefix)
  },
}
